import type { FC } from 'react';
import { Route } from 'react-router';
import { useStorageServiceRoot } from 'src/apis/storage/use-storage-service-root';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { RootRoutes } from 'src/components/root-routes';
import { PageSpinner } from 'src/components/spinner-container';
import { StorageOfferCreate } from 'src/pages/storage/offers-new/create';
import { StorageOfferDetails } from 'src/pages/storage/offers-new/details';
import { StorageOfferReservePriceEdit } from 'src/pages/storage/offers-new/details/allocation-proposal/recalculate';
import { StorageOfferEdit } from 'src/pages/storage/offers-new/edit';
import { StorageOffersOverviewNew } from 'src/pages/storage/offers-new/overview';
import { NotFound } from 'src/utils/errors';

export const StorageOffersNewRoot: FC = () => {
  const storageServiceRoot = useStorageServiceRoot();

  if (!storageServiceRoot.response) {
    return <PageSpinner />;
  }

  // TODO: remove FF check after all stages are migrated to Storage Service
  // As for now Storage Offers are treated within a deep link, we throw 404 instead of 403
  if (!storageServiceRoot.response.data._links?.getOffersOverviewPublic) {
    throw new NotFound();
  }

  return (
    <RootRoutes>
      <Route
        path="/storage/offers-new"
        element={
          <StorageOffersOverviewNew storageServiceRoot={storageServiceRoot} />
        }
      />
      <Route
        path="/storage/offers-new/:offerId"
        element={
          <StorageOfferDetails storageServiceRoot={storageServiceRoot} />
        }
      />
      <Route
        path="/storage/offers-new/create"
        element={<StorageOfferCreate storageServiceRoot={storageServiceRoot} />}
      />
      <Route
        path="/storage/offers-new/:offerId/edit"
        element={<StorageOfferEdit storageServiceRoot={storageServiceRoot} />}
      />
      <Route
        path="/storage/offers-new/:offerId/edit-reserve-price"
        element={
          <StorageOfferReservePriceEdit
            storageServiceRoot={storageServiceRoot}
          />
        }
      />

      <Route path="*" element={<ThrowNotFound />} />
    </RootRoutes>
  );
};
